import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useCustomMutation, useInvalidate } from "@refinedev/core";
import { useTranslation } from "../../../../hooks/useTranslation";
import LoadingButton from "@mui/lab/LoadingButton";

export const CancelShipmentDialog = ({
  orderBarcode,
  open,
  onClose,
  id,
}: {
  orderBarcode: string;
  open: boolean;
  onClose: () => void;
  id: string;
}) => {
  const { translate, translateWithoutPrefix } = useTranslation(
    "pages.orderDetails.shipmentRow.cancelDialog"
  );

  const { mutate, isLoading } = useCustomMutation();
  const invalidate = useInvalidate();

  const handleCancelShipment = () => {
    mutate(
      {
        url: `orders/${orderBarcode}/shipment/${id}`,
        method: "delete",
        values: {},
        successNotification: () => {
          return {
            message: translate("successMessage"),
            type: "success",
          };
        },
      },
      {
        onSuccess: () => {
          invalidate({
            resource: "all",
            invalidates: ["all"],
          });

          onClose();
        },
      }
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
        {translate("title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{translate("description")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {translateWithoutPrefix("buttons.cancel")}
        </Button>
        <LoadingButton onClick={handleCancelShipment} loading={isLoading}>
          {translateWithoutPrefix("buttons.confirm")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
